import React, {
  useState,
  useEffect,
  componentDidMount,
  useCallback
} from "react";
import {
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Row,
  FormGroup,
  Label,
  InputGroup
} from "reactstrap";
import "./stylesDashboard.scss";
import { Client, Account, Databases, Query } from "appwrite";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { withTranslation } from "react-i18next";

const AreaOne = (props) => {
  const [mailReceive, setMailReceive] = useState();
  const [treatedMailReceive, settreatedMailReceive] = useState();
  const [messagesSentiments, setMessagesSentiments] = useState();
  const [loading, setLoading] = useState(true);
  const [hoverText, setHoverText] = useState([]);
  const [averageResponseTime, setAverageResponseTime] = useState(undefined);

  const theStatistics = props.statistics;
  const latestStatistic = props.statistics[0];

  const theMessages = props.messages;
  const thetreatedMessage = props.treatedMessage;
  const untreatedMessage = props.untreatedMessage;
  const totalProcessedMails = [];

  for (let i = 0; i < thetreatedMessage.length; i++) {
    totalProcessedMails.push(thetreatedMessage[i]);
  }

  for (let i = 0; i < untreatedMessage.length; i++) {
    totalProcessedMails.push(untreatedMessage[i]);
  }

  const handleDateChange = (theData) => {
    var data = theData;
    // console.log("data is: ", data);
    setMailReceive(data[0]);
    settreatedMailReceive(data[1]);
    setLoading(false);
    // Récupérer la liste des sentiments
    // const sentiments = data.map((message) => message.client_sentiment);
    // console.log("Liste des sentiments :", sentiments);
    // setMessagesSentiments(sentiments)
  };
  const handleIconMouseEnter = (value, text) => {
    setHoverText([value, text]);
  };

  const handleIconMouseLeave = () => {
    setHoverText("");
  };

  const calculateAverageResponseTime = (messages) => {
    let totalTimeDifference = 0;
    const convertMillisecondsToHMS = (milliseconds) => {
      let seconds = Math.floor((milliseconds / 1000) % 60);
      let minutes = Math.floor((milliseconds / (1000 * 60)) % 60);
      let hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
      seconds = seconds < 0 ? seconds * -1 : seconds;
      minutes = minutes < 0 ? minutes * -1 : minutes;
      hours = hours < 0 ? hours * -1 : hours;

      // return `${hours}h ${minutes}m ${seconds}s`;
      return `${seconds}`;
    };

    // console.log("untreatedMessage is: ", untreatedMessage);

    if (totalProcessedMails && totalProcessedMails.length > 0) {
      totalProcessedMails.forEach((message) => {
        const messageProcessDate = message.message_process_date ?? 0;
        const messageDate = message.message_process_end_date ?? 0;
        const timeDifference = messageDate - messageProcessDate;
        totalTimeDifference += timeDifference;
        // console.log("messageProcessDate is: ", messageProcessDate);
        // console.log("messageDate is: ", messageDate);
        // console.log("timeDifference is: ", timeDifference);
      });

      // console.log("totalTimeDifference is: ", totalTimeDifference);
      // console.log("totalProcessedMails.length is: ", totalProcessedMails.length);
      const avr = totalTimeDifference / totalProcessedMails.length;
      // console.log("calculateAverageResponseTime is: ", convertMillisecondsToHMS(avr));
      setAverageResponseTime(convertMillisecondsToHMS(avr));
      return avr;
    }
  };

  useEffect(() => {
    const today = new Date();
    handleDateChange([theMessages, thetreatedMessage]);
    calculateAverageResponseTime(theMessages);

    // const startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0); // Début de la journée
    // const endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59); // Fin de la journée
    // getMessageData([startDate, endDate]);
  }, [theMessages, thetreatedMessage]);

  const [btnmenu1, setbtnmenu1] = useState(false);

  const today = new Date();
  const sixDaysAgo = new Date();
  sixDaysAgo.setDate(today.getDate() - 6);

  // Définissez les options pour formater la date
  const options = { year: "numeric", month: "long", day: "numeric" };

  // Formatez la date au format "jour mois année"
  // const [selectedStartDate, setSelectedStartDate] = useState(
  //   sixDaysAgo.toLocaleDateString(props.i18n.language + "-" + props.i18n.language.toUpperCase(), options)
  // );
  // const [selectedEndDate, setSelectedEndDate] = useState(
  //   today.toLocaleDateString(props.i18n.language + "-" + props.i18n.language.toUpperCase(), options)
  // );

  function formatTime(milliseconds, isHour) {
    if (isHour) {
      // Convert milliseconds to hours and round to the nearest integer
      const hours = Math.round(milliseconds / (1000 * 60 * 60));
      return `${hours} h`;
    } else {
      // Convert milliseconds to seconds and round to the nearest integer
      const seconds = Math.round(milliseconds / 1000);
      return `${seconds} s`;
    }
  }

  const svgs = {
    info_icon: (
      <svg
        fill="currentColor"
        width="30"
        height="auto"
        viewBox="-1920 -1920 5760.00 5760.00"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" style={{ strokeWidth: "0" }} />

        <g
          id="SVGRepo_tracerCarrier"
          style={{ strokeLinecap: "round", strokeLinejoin: "round" }}
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            style={{ fillRule: "evenodd" }}
            d="M960 0c530.193 0 960 429.807 960 960s-429.807 960-960 960S0 1490.193 0 960 429.807 0 960 0Zm0 101.053c-474.384 0-858.947 384.563-858.947 858.947S485.616 1818.947 960 1818.947 1818.947 1434.384 1818.947 960 1434.384 101.053 960 101.053Zm-42.074 626.795c-85.075 39.632-157.432 107.975-229.844 207.898-10.327 14.249-10.744 22.907-.135 30.565 7.458 5.384 11.792 3.662 22.656-7.928 1.453-1.562 1.453-1.562 2.94-3.174 9.391-10.17 16.956-18.8 33.115-37.565 53.392-62.005 79.472-87.526 120.003-110.867 35.075-20.198 65.9 9.485 60.03 47.471-1.647 10.664-4.483 18.534-11.791 35.432-2.907 6.722-4.133 9.646-5.496 13.23-13.173 34.63-24.269 63.518-47.519 123.85l-1.112 2.886c-7.03 18.242-7.03 18.242-14.053 36.48-30.45 79.138-48.927 127.666-67.991 178.988l-1.118 3.008a10180.575 10180.575 0 0 0-10.189 27.469c-21.844 59.238-34.337 97.729-43.838 138.668-1.484 6.37-1.484 6.37-2.988 12.845-5.353 23.158-8.218 38.081-9.82 53.42-2.77 26.522-.543 48.24 7.792 66.493 9.432 20.655 29.697 35.43 52.819 38.786 38.518 5.592 75.683 5.194 107.515-2.048 17.914-4.073 35.638-9.405 53.03-15.942 50.352-18.932 98.861-48.472 145.846-87.52 41.11-34.26 80.008-76 120.788-127.872 3.555-4.492 3.555-4.492 7.098-8.976 12.318-15.707 18.352-25.908 20.605-36.683 2.45-11.698-7.439-23.554-15.343-19.587-3.907 1.96-7.993 6.018-14.22 13.872-4.454 5.715-6.875 8.77-9.298 11.514-9.671 10.95-19.883 22.157-30.947 33.998-18.241 19.513-36.775 38.608-63.656 65.789-13.69 13.844-30.908 25.947-49.42 35.046-29.63 14.559-56.358-3.792-53.148-36.635 2.118-21.681 7.37-44.096 15.224-65.767 17.156-47.367 31.183-85.659 62.216-170.048 13.459-36.6 19.27-52.41 26.528-72.201 21.518-58.652 38.696-105.868 55.04-151.425 20.19-56.275 31.596-98.224 36.877-141.543 3.987-32.673-5.103-63.922-25.834-85.405-22.986-23.816-55.68-34.787-96.399-34.305-45.053.535-97.607 15.256-145.963 37.783Zm308.381-388.422c-80.963-31.5-178.114 22.616-194.382 108.33-11.795 62.124 11.412 115.76 58.78 138.225 93.898 44.531 206.587-26.823 206.592-130.826.005-57.855-24.705-97.718-70.99-115.729Z"
          />{" "}
        </g>
      </svg>
    )
  };
  return (
    <React.Fragment>
      <div
        style={{
          marginBottom: props.full ? "0px" : "24px"
        }}
      >
        <div
          className="area-one"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "24px"
          }}
        >
          <Row>
            <Col xl={3}>
              <Card className="cream cream-card mb-0">
                <CardBody>
                  <div className="d-flex text-muted">
                    <div className="flex-grow-1 row">
                      <div className="mb-1 d-flex col-auto box-title-black font-primary">
                        {props.t("Messages reçus")}
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            right: "0",
                            transform: "translate(40%, -36%)"
                          }}
                          className="box-icon-black font-primary"
                          onMouseEnter={() =>
                            handleIconMouseEnter(1, props.t("area_one_msg_1"))
                          }
                          onMouseLeave={handleIconMouseLeave}
                        >
                          {hoverText[0] === 1 && (
                            <div
                              className="hover-text font-primary"
                              style={{
                                zIndex: "9999",
                                height: "fit-content",
                                top: "0",
                                right: "0",
                                padding: "5px 10px",
                                fontWeight: "400",
                                transform: "translate(0%, -100%)"
                              }}
                            >
                              {hoverText[1]}
                            </div>
                          )}
                          {svgs.info_icon}
                        </div>
                      </div>
                      {/* <span className='color-dark-black' style={{ fontSize: '13px',}}>({props.t("30 derniers jours")})</span> */}

                      <Row className="">
                        <Col>
                          {latestStatistic ? (
                            <h5 className="box-value-black font-primary">
                              {latestStatistic.mail_count ?? "-"}
                            </h5>
                          ) : (
                            <h5 className="box-value-black font-primary">--</h5>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={3} sm={6}>
              <Card className="light-card mb-0">
                <CardBody>
                  <div className="d-flex text-muted">
                    <div className="flex-grow-1 row">
                      <div className="mb-1 d-flex col-auto box-title-black font-primary">
                        {props.t("Messages traités")}
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            right: "0",
                            transform: "translate(40%, -36%)"
                          }}
                          className="box-icon-black font-primary"
                          onMouseEnter={() =>
                            handleIconMouseEnter(2, props.t("area_one_msg_2"))
                          }
                          onMouseLeave={handleIconMouseLeave}
                        >
                          {hoverText[0] === 2 && (
                            <div
                              className="hover-text font-primary"
                              style={{
                                zIndex: "9999",
                                height: "fit-content",
                                top: "0",
                                right: "0",
                                padding: "5px 10px",
                                fontWeight: "400",
                                transform: "translate(0%, -100%)"
                              }}
                            >
                              {hoverText[1]}
                            </div>
                          )}
                          {svgs.info_icon}
                        </div>
                      </div>
                      {/* <span className="color-dark-black" style={{ fontSize: '13px' }}>
                      ({props.t("% des e-mails entrants")})
                    </span> */}

                      <Row className="">
                        <Col>
                          {latestStatistic ? (
                            <h5 className="box-value-black font-primary">
                              {latestStatistic.traited_mail_count}
                            </h5>
                          ) : (
                            <h5 className="box-value-black font-primary">--</h5>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={3} sm={6}>
              <Card className="cream cream-card mb-0">
                <CardBody>
                  <div className="d-flex text-muted">
                    <div className="flex-grow-1 row">
                      <div className="mb-1 d-flex col-auto box-title-black font-primary">
                        {props.t("C.A Boutique")}
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            right: "0",
                            transform: "translate(40%, -36%)"
                          }}
                          className="box-icon-black"
                          onMouseEnter={() =>
                            handleIconMouseEnter(5, props.t("area_one_msg_5"))
                          }
                          onMouseLeave={handleIconMouseLeave}
                        >
                          {hoverText[0] === 5 && (
                            <div
                              className="hover-text font-primary"
                              style={{
                                zIndex: "9999",
                                height: "fit-content",
                                top: "0",
                                right: "0",
                                padding: "5px 10px",
                                fontWeight: "400",
                                transform: "translate(0%, -100%)"
                              }}
                            >
                              {hoverText[1]}
                            </div>
                          )}
                          {svgs.info_icon}
                        </div>
                      </div>
                      {/* <span>&nbsp;</span> */}

                      <Row className="">
                        {localStorage.getItem("companyId") ===
                        "6732fcbb0001cd2be056" ? (
                          <Col>
                            {latestStatistic ? (
                              <h5 className="box-value-black font-primary">
                                {latestStatistic.mail_receive}{" "}
                              </h5>
                            ) : (
                              <h5 className="box-value-black font-primary">
                                --
                              </h5>
                            )}
                          </Col>
                        ) : (
                          <Col>
                            {treatedMailReceive ? (
                              <h5 className="box-value-black font-primary">
                                {" "}
                                -{" "}
                              </h5>
                            ) : (
                              <h5 className="box-value-black font-primary">
                                --
                              </h5>
                            )}
                          </Col>
                        )}
                      </Row>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={3}>
              <Card className="light-card mb-0">
                <CardBody>
                  <div className="d-flex text-muted">
                    <div className="flex-grow-1 row">
                      <div className="mb-1 d-flex col-auto box-title-black font-primary">
                        {props.t("C.A Synibox")}
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            right: "0",
                            transform: "translate(40%, -36%)"
                          }}
                          className="box-icon-black font-primary"
                          onMouseEnter={() =>
                            handleIconMouseEnter(6, props.t("area_one_msg_6"))
                          }
                          onMouseLeave={handleIconMouseLeave}
                        >
                          {hoverText[0] === 6 && (
                            <div
                              className="hover-text font-primary"
                              style={{
                                zIndex: "9999",
                                height: "fit-content",
                                top: "0",
                                right: "0",
                                padding: "5px 10px",
                                fontWeight: "400",
                                transform: "translate(0%, -100%)"
                              }}
                            >
                              {hoverText[1]}
                            </div>
                          )}
                          {svgs.info_icon}
                        </div>
                      </div>
                      {/* <span>&nbsp;</span> */}

                      <Row className="">
                        {localStorage.getItem("companyId") ===
                        "6732fcbb0001cd2be056" ? (
                          <Col>
                            {latestStatistic ? (
                              <h5 className="box-value-black font-primary">
                                {latestStatistic.treated_mail_receive}{" "}
                              </h5>
                            ) : (
                              <h5 className="box-value-black font-primary">
                                --
                              </h5>
                            )}
                          </Col>
                        ) : (
                          <Col>
                            {mailReceive ? (
                              <h5 className="box-value-black font-primary">
                                {" "}
                                -{" "}
                              </h5>
                            ) : (
                              <h5 className="box-value-black font-primary">
                                --
                              </h5>
                            )}
                          </Col>
                        )}
                      </Row>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {props.full && (
            <Row>
              <Col xl={3}>
                <Card className="light-card">
                  <CardBody>
                    <div className="d-flex text-muted">
                      <div className="flex-grow-1 row">
                        <div className="mb-1 d-flex col-auto box-title-black font-primary">
                          {props.t("Taux Efficacité Synibox")}
                          <div
                            style={{
                              position: "absolute",
                              top: "0",
                              right: "0",
                              transform: "translate(40%, -36%)"
                            }}
                            className="box-icon-black font-primary"
                            onMouseEnter={() =>
                              handleIconMouseEnter(3, props.t("area_one_msg_3"))
                            }
                            onMouseLeave={handleIconMouseLeave}
                          >
                            {hoverText[0] === 3 && (
                              <div
                                className="hover-text font-primary"
                                style={{
                                  zIndex: "9999",
                                  height: "fit-content",
                                  top: "0",
                                  right: "0",
                                  padding: "5px 10px",
                                  fontWeight: "400",
                                  transform: "translate(0%, -100%)"
                                }}
                              >
                                {hoverText[1]}
                              </div>
                            )}
                            {svgs.info_icon}
                          </div>
                        </div>
                        {/* <span>&nbsp;</span> */}

                        <Row className="">
                          <Col>
                            {latestStatistic ? (
                              <h5 className="box-value-black font-primary">
                                {Math.round(
                                  latestStatistic.percent_treated_mail_count
                                )}
                                %
                              </h5>
                            ) : (
                              <h5 className="box-value-black font-primary">
                                --
                              </h5>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={3} sm={6}>
                <Card className="cream cream-card">
                  <CardBody>
                    <div className="d-flex text-muted">
                      <div className="flex-grow-1 row">
                        <div className="mb-1 d-flex col-auto box-title-black font-primary">
                          {props.t("Temps Épargné Synibox")}
                          <div
                            style={{
                              position: "absolute",
                              top: "0",
                              right: "0",
                              transform: "translate(40%, -36%)"
                            }}
                            className="box-icon-black"
                            onMouseEnter={() =>
                              handleIconMouseEnter(4, props.t("area_one_msg_4"))
                            }
                            onMouseLeave={handleIconMouseLeave}
                          >
                            {hoverText[0] === 4 && (
                              <div
                                className="hover-text font-primary"
                                style={{
                                  zIndex: "9999",
                                  height: "fit-content",
                                  top: "0",
                                  right: "0",
                                  padding: "5px 10px",
                                  fontWeight: "400",
                                  transform: "translate(0%, -100%)"
                                }}
                              >
                                {hoverText[1]}
                              </div>
                            )}
                            {svgs.info_icon}
                          </div>
                        </div>
                        {/* <span className="color-black" style={{ fontSize: '13px' }}>
                      ({props.t("Basé sur 3min par email")})
                    </span> */}

                        <Row className="">
                          <Col className="d-flex align-items-end">
                            {latestStatistic ? (
                              <h5 className="box-value-black font-primary">
                                {formatTime(latestStatistic.saved_time, true)}
                              </h5>
                            ) : (
                              <h5 className="box-value-black font-primary">
                                --
                              </h5>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={3} sm={6}>
                <Card className="light-card mb-0">
                  <CardBody>
                    <div className="d-flex text-muted">
                      <div className="flex-grow-1 row">
                        <div className="mb-1 d-flex col-auto box-title-black font-primary">
                          {props.t("Réponse Moy. Synibox")}
                          <div
                            style={{
                              position: "absolute",
                              top: "0",
                              right: "0",
                              transform: "translate(40%, -36%)"
                            }}
                            className="box-icon-black font-primary"
                            onMouseEnter={() =>
                              handleIconMouseEnter(7, props.t("area_one_msg_7"))
                            }
                            onMouseLeave={handleIconMouseLeave}
                          >
                            {hoverText[0] === 7 && (
                              <div
                                className="hover-text font-primary"
                                style={{
                                  zIndex: "9999",
                                  height: "fit-content",
                                  top: "0",
                                  right: "0",
                                  padding: "5px 10px",
                                  fontWeight: "400",
                                  transform: "translate(0%, -100%)"
                                }}
                              >
                                {hoverText[1]}
                              </div>
                            )}
                            {svgs.info_icon}
                          </div>
                        </div>
                        {/* <span>&nbsp;</span> */}
                        <Row className="">
                          <Col className="d-flex align-items-end">
                            {latestStatistic ? (
                              <h5 className="box-value-black font-primary">
                                {formatTime(
                                  latestStatistic.average_response_time
                                )}
                              </h5>
                            ) : (
                              <h5 className="box-value-black font-primary">
                                --
                              </h5>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={3}>
                <Card className="cream cream-card mb-0">
                  <CardBody>
                    <div className="d-flex text-muted">
                      <div className="flex-grow-1 row">
                        <div className="mb-1 d-flex col-auto box-title-black font-primary">
                          {props.t("Économ. Salariales")}
                          <div
                            style={{
                              position: "absolute",
                              top: "0",
                              right: "0",
                              transform: "translate(40%, -36%)"
                            }}
                            className="box-icon-black font-primary"
                            onMouseEnter={() =>
                              handleIconMouseEnter(8, props.t("area_one_msg_8"))
                            }
                            onMouseLeave={handleIconMouseLeave}
                          >
                            {hoverText[0] === 8 && (
                              <div
                                className="hover-text font-primary"
                                style={{
                                  zIndex: "9999",
                                  height: "fit-content",
                                  top: "0",
                                  right: "0",
                                  padding: "5px 10px",
                                  fontWeight: "400",
                                  transform: "translate(0%, -100%)"
                                }}
                              >
                                {hoverText[1]}
                              </div>
                            )}
                            {svgs.info_icon}
                          </div>
                        </div>
                        {/* <span>&nbsp;</span> */}
                        <Row className="">
                          <Col>
                            <h5 className="box-value-black font-primary">
                              9 861€
                            </h5>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(AreaOne);
